module.exports = __webpack_public_path__ + "img/vegetable-fiddleheads-350x184.2fdee825.jpg";